import app from './../index';

export default class KundeController {

  constructor($routeParams) {
    if ($routeParams.id === "new") {
      this.kunden = new app.api.kunden();
      this.kunden.$resolved = true;
    } else {
      this.kunden = app.api.kunden.get({ id: $routeParams.id });
    }
  }

  save() {
    this.kunden.$save(() => {
      app.$window.history.back();
    });
  }
}

KundeController.$inject = ['$routeParams'];



// WEBPACK FOOTER //
// ./app/kunden/kundeController.js